import { RFQCreatedEvent } from "@/lib/queries/types";
import dayjs from "dayjs";
import StarIcon from "~icons/fa6-regular/star";
import { datetimeFormat } from "./utils";

export default function RfqCreated({ data }: { data: RFQCreatedEvent }) {
  const { event_time, note } = data;

  return (
    <>
      <div className="flex gap-1 items-center py-2">
        <div className="rounded-full bg-slate-100 p-1">
          <StarIcon className="size-4" />
        </div>
        <div className="font-bold ml-3">RFQ Created</div>
        <time className="text-sm text-slate-500" dateTime={event_time}>
          {dayjs(event_time).format(datetimeFormat)}
        </time>
      </div>
      {note && (
        <div className="text-sm mt-2">
          <span className="font-semibold">Note:</span>
          <span className="ml-2 text-slate-500">{note}</span>
        </div>
      )}
    </>
  );
}
